<template>
  <div class="login-tag ">
    <div class="login-device is-flex is-justify-content-center is-align-items-center">
      <div class="card">
         <header class="">
          <div class="card-header-title has-text-dark">
            <h3 class="modal-title is-size-3 has-text-weight-bold has-text-dark">
              Login Pending, Device Limit Reached
            </h3>
          </div>
         </header>
          <div class="card-content is-size-3 line-height">
            <p class="has-text-black-ter mb-3 ">
          Your current license allows for 12 concurrent logins per user.
        </p>
        <p class="has-text-black-ter">
          To log in with this account, you must log out of one active device.
          Please choose a device to log out of.
        </p>
            <div class="device-body mt-4 column is-full pl-0 pr-0">
          <div
            v-for="(device, index) in devices"
            :key="index"
          >
          <div class="columns">
            <div class="column is-narrow mf-radio pr-0">
              <input
              type="radio"
              name="device"
              v-model="selectedDevice"
              :value="device"
            />
            </div>
            <div class="column is-size-3 has-text-weight-bold has-text-dark">
              <p>{{ device.platform }}</p>
              <div class="is-flex is-justify-content-space-between is-align-items-center device-name">
                <span>
                   {{ device.deviceType }}
                </span>
                <span>
                   Last login: {{ formatDate(device.initializedAt) }}
                </span>
              </div>
            </div>
          </div>
          </div>
          <p v-if="!devices.length" class="is-size-3 has-text-weight-normal has-text-dark">
            No other active devices found.
          </p>
        </div>
          </div>
           <footer
          class="card-footer is-justify-content-flex-end -small"
        >
        <div class="buttons has-text-weight-normal">
           <button class="button is-dark" :disabled="!selectedDevice"
            @click="logoutSelectedDevice"
          >
            Log Out Of Selected Device
           </button>
            <button class="button is-outlined"
              @click="cancelLogin">
            Back
            </button>
        </div>
        </footer>
      </div>
     
      <o-loading :active="isLoading" :full-page="true" :can-cancel="false" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';
import _ from 'lodash';

import User from '@/models/Users';
import Version from '@/appVersion.json';
import { getBrowserType } from '@/utils/Browser';
import moment from 'moment';

export default {
  name: 'LoginDevice',

  setup() {
    const route = useRoute();
    const router = useRouter();
    const toast = useToast();
    const store = useStore();

    const isLoading = ref(false);
    const devices = ref([]);
    const selectedDevice = ref(null);

    const concurrentDeviceOTK = route.params.concurrentDeviceOTK;

    const landingPage = {
      home: '/home',
      mm: '/materials/preparation',
      prefabs: '/prefabs-list',
      pm: '/manager/detailing',
      scm: '/scm/production-status/order-view',
      schedules: 'schedule-list',
    };

    const fetchDevices = async () => {
      isLoading.value = true;
      try {
        devices.value = await User.loggedInDevices({
          concurrentOTK: concurrentDeviceOTK,
        });
      } catch {
        toast.error('Failed to load devices');
      } finally {
        isLoading.value = false;
      }
    };

    const logoutSelectedDevice = async () => {
      isLoading.value = true;
      try {

       const result =  await User.logoutDevice({
          concurrentDeviceOTK,
          hw: selectedDevice.value.hw,
          device: {
            platform: getBrowserType(),
            appVersion: Version.appVersion,
            deviceType: selectedDevice.value.deviceType,
          },
        });
        console.log(result)
        localStorage.setItem('auth-token', result.token);
        localStorage.setItem('licenseExpiresIn', result.user.licenseExpiresIn);
        localStorage.setItem('refreshableUntil', result.user.refreshableUntil);
        await store.dispatch('getUserData');
        store.commit('setLoggedIn', true);
        await store.getters.userPromise;
        const user = store.state.userData;
        await store.dispatch('updateProjects');

        ['projects', 'projectsAndGI'].forEach((key) => {
          if (user.rememberLastUsedProjects) {
            if (store.state.queryParams.isActiveSelected[key]) {
              store.commit('setIsActiveSelectedVal', key, false);
            }

            if (_.get(store.state.queryParams, 'projects.length', 0) === 0) {
              store.commit('setQueryParams', {
                [key]: store.state.queryParams._projects,
              });
            }
          } else {
            store.dispatch('selectActiveProjects', key);
          }
        });

        router.push({
          path: landingPage[user.defaultLanding],
        });
      } catch (err) {
        console.log(err);
        toast.error('Unable to complete login');
      } finally {
        isLoading.value = false;
      }
    };

    const cancelLogin = () => router.push('/login');

    const formatDate = (date) =>
      date ? moment(date).format('MM/DD/YYYY') : '--';
      

    onMounted(fetchDevices);

    return {
      isLoading,
      devices,
      selectedDevice,
      logoutSelectedDevice,
      cancelLogin,
      formatDate,
    };
  },
};
</script>
 



